import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./guards/auth-guard";
import { NoAuthGuard } from "./guards/no-auth-guard";
import { Home } from "./pages/home/home";
import { Login } from "./account/login/login";
import { Profile } from "./account/profile/profile";
import { Registration } from "./account/registration/registration";
import { ForgotPassword } from "./account/forgot-password/forgot-password";
import { UpdateUserProfile } from "./account/update-user-profile/update-user-profile";
import { Verify } from "./account/verify/verify";


const routes: Routes = [
  { path: "Home", component: Home, canActivate: [AuthGuard] },
  {
    path: "home",
    component: Home,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: "Home",
    },
  },
  { path: "login", component: Login },
  { path: "registration", component: Registration },
  { path: "forgot-password", component: ForgotPassword },

  {
    path: "profile",
    component: Profile,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: "Profile",
    },
  },
  {
    path: "admin",
    loadChildren: () =>
      import("./pages/admin/admin-module.js").then((m) => m.AdminModule),
    data: { breadcrumb: "Admin" },
  },
  {
    path: "buyer",
    loadChildren: () =>
      import("./pages/buyer/buyer-module.js").then((m) => m.BuyerModule),
    data: { breadcrumb: "Buyer" },
  },
  {
    path: "seller",
    loadChildren: () =>
      import("./pages/seller/seller-module.js").then((m) => m.SellerModule),
    data: { breadcrumb: "Seller" },

  },
  {
    path: "investor",
    loadChildren: () =>
      import("./pages/investor/investor-module.js").then((m) => m.InvestorModule),
    data: { breadcrumb: "Investor" },
  },
  {
    path: "verification",
    loadChildren: () =>
      import("./pages/verification/verification-module.js").then((m) => m.VerificationModule)
  },
  {
    path: "common",
    loadChildren: () =>
      import("./pages/common-features/common-features-module.js").then(
        (m) => m.CommonFeaturesModule
      ),
  },
  {
    path: "crm",
    loadChildren: () =>
      import("./pages/crm/crm-module.js").then(
        (m) => m.CrmModule
      ),
  },
  {
    path: "update-user-profile",
    component: UpdateUserProfile,
    canActivate: [AuthGuard],
  },
  {
    path: "verify/:id",
    component: Verify,
  },
  {
    path: "landing-page",
    redirectTo: "",
    pathMatch: "full",
  },
  {
    path: "",
    loadChildren: () =>
      import("./pages/landing-page/landing-page-module.js").then((m) => m.LandingPageModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
